import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-paymnet-receipt-indetail-officer',
  templateUrl: './paymnet-receipt-indetail-officer.component.html',
  styleUrl: './paymnet-receipt-indetail-officer.component.scss'
})
export class PaymnetReceiptIndetailOfficerComponent {



   constructor(
        private dialogRef: MatDialogRef<PaymnetReceiptIndetailOfficerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
      ) {
      }
    
  
  
    PaymentadvtOffInDFormBenas: any = []
    reportType:any
    startDate :any
    endDate :any
    repName :any
    offRepName:any
    advtName :any
    issueDates:any
    issueDates1:any
  
  PaymentReceiptRegister = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      rep_name: new FormControl(),
      off_rep_name: new FormControl(),
      issuename: new FormControl(),
      issueDates:new FormControl(),
    });
    startDate_contract: any;
    enddate_contract: any;
    PaymentadvtOffInDTotal2: number = 0;
    PaymentadvtOffInDTotal3: number = 0;
    PaymentadvtOffInDTotal: number = 0;
    ngOnInit(): void {
  
     debugger
     let repname: any = this.data['repName'];
  
      // Then check if it's not empty and convert to array
      if (repname != "") {
        repname = repname; // This puts the single value in an array
      }
  
      this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issueDates;
      this.issueDates1 = this.data['issue_date'];
  
  
      const req: any = {
        "rep_name": repname,
        "start_date": this.startDate,
        "end_date": this.endDate,
        "off_rep_name": this.offRepName,
        "advt_name": this.data['name'],
        // // "issue_name" : this.advtName,
        // "issue_date": this.issueDates
        "issue_name": "",
        "issue_date": this.issueDates
    
    
      }


      // officer in detail
    this.service.getPaymentRegiOffInDetails(req).subscribe((data: any) => {
      console.log("new", data)
      this.PaymentadvtOffInDFormBenas = data as any;
      console.log(this.PaymentadvtOffInDFormBenas, "newlist 3 loop")
      // Reset totals
      // this.PaymentadvtOffInDTotal = 0;
      this.PaymentadvtOffInDTotal2 = 0;
      this.PaymentadvtOffInDTotal3 = 0;



      // Calculate totals
      for (let repData of this.PaymentadvtOffInDFormBenas) {
        this.PaymentadvtOffInDTotal2 += parseInt(repData.total) || 0;

        for (let data1 of repData.rep_data) {
          // this.PaymentadvtOffInDTotal += parseInt(data1.rcv_amt) || 0;
          // // this.PaymentadvtOffInDTotal2 += parseInt(repdata.total) || 0;
          // this.PaymentadvtOffInDTotal3 += parseInt(data1.rcv_amt) || 0;
        }
      }
      console.log("offcr total", this.PaymentadvtOffInDTotal)
    });

    }

//     printPage4() {
//       // this.show = true;
//       const printSection = document.getElementById('print-section');
//       if (!printSection) {
//         console.error("Print section not found!");
//         return;
//       }
  
//       const printContent = printSection.innerHTML;
  
//       const screenWidth = window.screen.availWidth;
//       const windowWidth = 1400;
//       const leftPosition = screenWidth - windowWidth - 50;
  
//       const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);
  
//       if (printWindow) {
//         printWindow.document.open();
//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Print Report</title>
//                     <style>
//                         @media print {
//                             @page {
//                                 size: A3 landscape;
//                                 margin: 3mm;
//                             }
//                             .report-container {
//     background: rgb(15, 15, 15);
//     border-radius: 12px;
//     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//     overflow: hidden;
//     margin: 20px auto;
// }

//   *, th, td, .table tfoot td {
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }

//   /* Strongly enforce footer background color */
//   .table tfoot td {
//     background-color: #c8e6c9 !important;
//     color: #000 !important;
//     font-weight: bold !important;
//     border-top: 3px solid #4caf50 !important;
//   }

// .report-header {
//     background: #f8f9fa;
//     color: #333333;
//     padding: 20px;
//     text-align: center;
// }

// .report-title {
//     font-size: 18px;
//     font-weight: bold;
//     margin-bottom: 10px;
// }

// .report-subtitle {
//     font-size: 14px;
//     opacity: 0.9;
// }

// .table-responsive {
//     overflow-x: auto;
//     background: white;
// }

// .styled-table {
//     width: 90%;
//     border-collapse: collapse;
//     font-size: 14px;
//     font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
// }

// .styled-table thead {
//     background: #e9ecef;
//     color: #495057;
// }

// .styled-table thead th {
//     padding: 15px 10px;
//     text-align: center;
//     font-weight: 600;
//     border: 1px solid #dee2e6;
//     text-shadow: none;
// }

// .styled-table tbody td {
//     padding: 8px 10px;
//     border: 1px solid #e2e8f0;
//     vertical-align: middle;
//       white-space: nowrap;
//     color: #000000;
// }

// .styled-table tbody tr:nth-child(even) {
//     background-color: #f8fafc;
// }

// .styled-table tbody tr:hover {
//     background-color: #e2e8f0;
//     transition: background-color 0.2s ease;
// }

// .office-header {
//     background: #d1ecf1 !important;
//     color: #0c5460 !important;
//     font-weight: bold !important;
//     font-size: 14px !important;
// }

// .rep-header {
//     background: #d4edda !important;
//     color: #155724 !important;
//     font-weight: bold !important;
//     font-size: 14px !important;
// }

// .rep-total {
//     background: #fff3cd !important;
//     color: #856404 !important;
//     font-weight: bold !important;
//     font-size: 13px !important;
// }

// .office-total {
//     background: #f8d7da !important;
//     color: #721c24 !important;
//     font-weight: bold !important;
//     font-size: 14px !important;
// }

// .styled-table tr{
//     background: #e9ecef;
//     color: #495057;
// }

// .styled-table tr td {
//     padding: 15px 10px;
//     font-weight: bold;
//     font-size: 16px;
//     border: 1px solid #dee2e6;
// }

// .data-row td {
//     font-size: 12px !important;
//     font-weight: 500 !important;
//     color: #000000 !important;
// }

// .amount-cell {
//     font-family: 'Courier New', monospace !important;
//     background: #f7fafc !important;
//     color: #000000 !important;
// }

// .button-container {
//     background: white;
//     padding: 20px;
//     display: flex;
//     justify-content: flex-end;
//     gap: 10px;
//     border-top: 1px solid #e2e8f0;
// }

// .modern-btn {
//     padding: 10px 20px;
//     border: none;
//     border-radius: 6px;
//     cursor: pointer;
//     font-weight: 600;
//     text-transform: uppercase;
//     letter-spacing: 0.5px;
//     transition: all 0.3s ease;
//     font-size: 12px;
// }

// .btn-primary-modern {
//     background: #6c757d;
//     color: white;
//     box-shadow: 0 4px 15px rgba(108, 117, 125, 0.4);
// }

// .btn-primary-modern:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 6px 20px rgba(108, 117, 125, 0.6);
// }

// .btn-secondary-modern {
//     background: #e2e8f0;
//     color: #4a5568;
//     border: 1px solid #cbd5e0;
// }

// .btn-secondary-modern:hover {
//     background: #cbd5e0;
//     transform: translateY(-1px);
// }
//     .report-container {
//     background: rgb(15, 15, 15);
//     border-radius: 12px;
//     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//     overflow: hidden;
//     margin: 20px auto;
// }

// .report-header {
//     background: #f8f9fa;
//     color: #333333;
//     padding: 20px;
//     text-align: center;
// }

// .report-title {
//     font-size: 18px;
//     font-weight: bold;
//     margin-bottom: 10px;
// }

// .report-subtitle {
//     font-size: 14px;
//     opacity: 0.9;
// }

// .table-responsive {
//     overflow-x: auto;
//     background: white;
// }

// .styled-table {
//     width: 100%;
//     border-collapse: collapse;
//     font-size: 13px;
//     font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
// }

// .styled-table thead {
//     background: #e9ecef;
//     color: #495057;
// }

// .styled-table thead th {
//     padding: 15px 10px;
//     text-align: center;
//     font-weight: 600;
//     border: 1px solid #dee2e6;
//     text-shadow: none;
// }

// .styled-table tbody td {
//     padding: 8px 10px;
//     border: 1px solid #e2e8f0;
//     vertical-align: middle;
//     color: #000000;
// }

// .styled-table tbody tr:nth-child(even) {
//     background-color: #f8fafc;
// }

// .styled-table tbody tr:hover {
//     background-color: #e2e8f0;
//     transition: background-color 0.2s ease;
// }

// .office-header {
//     background: #d1ecf1 !important;
//     color: #0c5460 !important;
//     font-weight: bold !important;
//     font-size: 14px !important;
// }

// .rep-header {
//     background: #d4edda !important;
//     color: #155724 !important;
//     font-weight: bold !important;
//     font-size: 14px !important;
// }

// .rep-total {
//     background: #fff3cd !important;
//     color: #856404 !important;
//     font-weight: bold !important;
//     font-size: 13px !important;
// }

// .office-total {
//     background: #f8d7da !important;
//     color: #721c24 !important;
//     font-weight: bold !important;
//     font-size: 14px !important;
// }

// .styled-table tfoot {
//     background: #e9ecef;
//     color: #495057;
// }

// .styled-table tfoot td {
//     padding: 15px 10px;
//     font-weight: bold;
//     font-size: 16px;
//     border: 1px solid #dee2e6;
// }

// .data-row td {
//     font-size: 12px !important;
//     font-weight: 500 !important;
//     color: #000000 !important;
// }

// .amount-cell {
//     font-family: 'Courier New', monospace !important;
//     background: #f7fafc !important;
//     color: #000000 !important;
// }

// .button-container {
//     background: white;
//     padding: 20px;
//     display: flex;
//     justify-content: flex-end;
//     gap: 10px;
//     border-top: 1px solid #e2e8f0;
// }

// .modern-btn {
//     padding: 10px 20px;
//     border: none;
//     border-radius: 6px;
//     cursor: pointer;
//     font-weight: 600;
//     text-transform: uppercase;
//     letter-spacing: 0.5px;
//     transition: all 0.3s ease;
//     font-size: 12px;
// }

// .btn-primary-modern {
//     background: #6c757d;
//     color: white;
//     box-shadow: 0 4px 15px rgba(108, 117, 125, 0.4);
// }

// .btn-primary-modern:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 6px 20px rgba(108, 117, 125, 0.6);
// }

// .btn-secondary-modern {
//     background: #e2e8f0;
//     color: #4a5568;
//     border: 1px solid #cbd5e0;
// }

// .btn-secondary-modern:hover {
//     background: #cbd5e0;
//     transform: translateY(-1px);
// }
   

//                             body {
//                                 font-family: Arial, sans-serif;
//                                 margin: 0;
                                
//                                 padding: 0;
//                                 font-size: 10px !important;
//                             }
//                             .print-section {
//                                 width: 100%;
//                                 margin: 0 auto;
//                                 padding: 0;
//                             }
//                             table {
//                                 width: 100% !important;
//                                 border-collapse: collapse;
//                                 table-layout: auto;
//                                 page-break-inside: auto;
//                             }
//                             tr {
//                                 page-break-inside: avoid;
//                                 page-break-after: auto;
//                             }
//                             th, td {
//                                 padding: 3px 5px !important;
//                                 border: 1px solid black !important;
//                                 font-size: 10px;
//                                 line-height: 1.3;
//                                 word-wrap: break-word;
//                                 overflow-wrap: break-word;
//                             }
//                             th {
//                                 background-color: #f2f2f2;
//                             }
//                             tr {
//                                 border-bottom: 1px solid black !important;
//                             }
//                             tr.header-row {
//                                 display: table-header-group;
//                             }
//                             td:nth-child(1) {
//                                 width: 1%;
//                                 text-align: left !important;
//                             }
//                             td:nth-child(2),
//                             td:nth-child(3),
//                             td:nth-child(4),
//                             td:nth-child(5),
//                             td:nth-child(6),
//                             td:nth-child(8) {
//                                 text-align: left !important;
//                             }
//                             td:nth-child(5) {
//                                 width: 5%;
//                                 white-space: normal;
//                             }
//                             td.advt-name {
//                                 max-width: 160px;
//                                 white-space: nowrap;
//                                 overflow: hidden;
//                                 text-overflow: ellipsis;
//                             }
//                             td:nth-child(n+12),
//                             td.amount,
//                             td[data-type="number"] {
//                                 text-align: right !important;
//                             }
//                             td.text,
//                             td[data-type="string"] {
//                                 text-align: left !important;
//                             }
//                             .br-right { border-right: 1px solid black !important; }
//                             .br-rightt { border-right: 4px solid black !important; }
//                             .br-bottom { border-bottom: 2px solid black !important; }
//                             .br-top { border-top: 2px solid black !important; }
//                             .noPrint { display: none !important; }
//                             .footer-line {
//                                 position: fixed;
//                                 bottom: 0;
//                                 left: 0;
//                                 width: 100%;
//                                 height: 2px;
//                                 background-color: black;
//                             }
//                             thead { display: table-header-group; }
//                             tfoot { display: table-footer-group; }
//                             td.balance-value {
//                                 text-align: right !important;
//                             }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     <div class="print-section">
//                         ${printContent}
//                         <div class="footer-line"></div>
//                     </div>
//                     <script>
//                        window.onload = function () {
//       const table = document.querySelector('table');
//       if (!table) {
//           console.error("Table not found");
//           return;
//       }
  
//       let headerRowIndex = -1;
//       const maxRowsToCheck = Math.min(10, table.rows.length);
  
//       // Find header row with column names
//       for (let i = 0; i < maxRowsToCheck; i++) {
//           const row = table.rows[i];
//           const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
  
//           if (row.cells.length >= 8 &&
//               (cellTexts.includes('Invoice No') ||
//                cellTexts.includes('Receipt No') ||
//                cellTexts.includes('Balance'))) {
//               headerRowIndex = i;
//               break;
//           }
//       }
  
//       if (headerRowIndex >= 0) {
//           // Create thead and move only the actual header row into it
//           let thead = table.querySelector('thead');
//           if (!thead) {
//               thead = document.createElement('thead');
//               table.insertBefore(thead, table.firstChild);
//           }
  
//           const headerRow = table.rows[headerRowIndex];
//           thead.appendChild(headerRow); // move actual header row
  
//           // Leave the other rows (like titles) in tbody so they don’t repeat
//       }
  
//       // Alignment processing (no change needed here)
//       const cells = document.querySelectorAll('td');
//       cells.forEach(cell => {
//           const content = cell.textContent.trim();
  
//           if (content.includes('येणे') ||
//               content.includes('Opening Balance') ||
//               content.match(/^\d+\s+येणे$/) ||
//               content.includes('Balance C/F') ||
//               content.includes('Total')) {
//               cell.style.textAlign = 'right';
//               cell.classList.add('balance-value');
//           }
  
//           const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
//           if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
//               cell.style.textAlign = 'right';
//               cell.classList.add('amount');
//           }
//       });
  
//       setTimeout(() => {
//           window.print();
//           setTimeout(() => { window.close(); }, 500);
//       }, 200);
//   };
  
//                     </script>
//                 </body>
//             </html>
//         `);
//         printWindow.document.close();
//       } else {
//         console.error("Failed to open print window.");
//       }
//     }


// printPage4() {
//   const printSection = document.getElementById('print-section');
//   if (!printSection) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printContent = printSection.innerHTML;

//   const screenWidth = window.screen.availWidth;
//   const windowWidth = 1400;
//   const leftPosition = screenWidth - windowWidth - 50;

//   const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }

//             body {
//               font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//               margin: 0;
//               padding: 10px;
//               background: white;
//             }

//             .report-container {
//               border-radius: 12px;
//               box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//               overflow: hidden;
//               margin: 20px auto;
//               background: white;
//             }

//            .report-header {
//     background: #f8f9fa;
//     color: #131212;
//     padding: 0;
//     display: flex;
//     justify-content: space-between;
//     align-items: stretch;
//     margin-bottom: 20px;
//     border: 2px solid #111111;
// }

// .company-name {
//     margin: 0;
//     font-size: 18px;
//     flex: 1;
//     text-align: left;
//     padding: 15px;
//     border-right: 2px solid #111111;
//     display: flex;
//     align-items: center;
//     white-space: nowrap;
// }

// .report-title {
//     margin: 0;
//     font-size: 18px;
//     flex: 2;
//     text-align: center;
//     font-weight: bold;
//     padding: 15px;
//     border-right: 2px solid #111111;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     white-space: nowrap;
// }

// .report-meta {
//     flex: 1;
//     text-align: right;
//     font-size: 18px;
//     padding: 15px;
//     display: flex;
//     flex-direction: column;
//     align-items: flex-end;
//     justify-content: center;

//     .report-type,
//     .date-range {
//         white-space: nowrap;
//     }
// }

//             .table-responsive {
//               overflow-x: auto;
//               background: white;
//               padding: 0 20px;
//             }

//             .styled-table {
//               width: auto !important;
//               border-collapse: collapse;
//               font-size: 14px;
//               font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//               table-layout: auto;
//             }

//             .styled-table th,
//             .styled-table td {
//               width: 1%;
//               white-space: nowrap;
//               padding: 8px 6px !important;
//             }

//             .styled-table th:nth-child(4),
//             .styled-table td:nth-child(4) {
//               white-space: normal;
//               width: auto;
//               max-width: 180px;
//             }

//             .styled-table th:nth-child(5),
//             .styled-table td:nth-child(5) {
//               white-space: normal;
//               width: auto;
//               max-width: 120px;
//             }

//             .styled-table thead {
//               background: #e9ecef;
//               color: #495057;
//             }

//             .styled-table thead th {
//               padding: 15px 10px;
//               text-align: center;
//               font-weight: 600;
//               border: 1px solid #111111;
//               text-shadow: none;
//             }

//             .styled-table tbody td {
//               padding: 8px 10px;
//               border: 1px solid #0d0d0e;
//               vertical-align: middle;
//               color: #000000;
//             }

//             .styled-table tbody tr:nth-child(even) {
//               background-color: #f8fafc;
//             }

//             .office-header {
//               background: #ffffff !important;
//               color: #0c5460 !important;
//               font-weight: bold !important;
//               font-size: 16px !important;
//             }

//             .office-header td {
//               padding: 10px !important;
//             }

//             .rep-header {
//               background: #f9faf9 !important;
//               color: #155724 !important;
//               font-weight: bold !important;
//               font-size: 16px !important;
//             }

//             .rep-header td {
//               padding: 10px !important;
//             }

//             .rep-total {
//               background: #fff3cd !important;
//               color: #856404 !important;
//               font-weight: bold !important;
//               font-size: 16px !important;
//             }

//             .rep-total td {
//               padding: 10px !important;
//             }

//             .office-total {
//               background: #f8d7da !important;
//               color: #721c24 !important;
//               font-weight: bold !important;
//               font-size: 16px !important;
//             }

//             .office-total td {
//               padding: 10px !important;
//             }

//             .styled-table tfoot {
//               background: #e9ecef;
//               color: #495057;
//             }

//             .grand-total {
//               background: #e9ecef !important;
//               color: #495057 !important;
//             }

//             .grand-total td {
//               padding: 15px 10px !important;
//               font-weight: bold !important;
//               font-size: 16px !important;
//               border: 1px solid #0e0f0f !important;
//             }

//             .data-row td {
//               font-size: 16px !important;
//               font-weight: 500 !important;
//               color: #000000 !important;
//             }

//             .nowrap {
//               white-space: nowrap;
//             }

//             .text-left {
//               text-align: left !important;
//             }

//             .text-right {
//               text-align: right !important;
//             }

//             .amount-cell {
//               font-family: 'Courier New', monospace !important;
//               background: #f7fafc !important;
//               color: #000000 !important;
//               font-weight: bold;
//               text-align: right !important;
//             }

//             /* Print-specific styles */
//             @media print {
//               @page {
//                 size: A3 landscape;
//                 margin: 10mm;
//               }

//               body {
//                 padding: 0;
//               }

//               .report-container {
//                 box-shadow: none;
//                 border-radius: 0;
//                 margin: 0;
//               }

//               * {
//                 -webkit-print-color-adjust: exact !important;
//                 print-color-adjust: exact !important;
//               }

//               .office-header,
//               .rep-header,
//               .rep-total,
//               .office-total,
//               .grand-total,
//               .styled-table thead,
//               .styled-table tfoot {
//                 -webkit-print-color-adjust: exact !important;
//                 print-color-adjust: exact !important;
//               }

//               table {
//                 page-break-inside: auto;
//               }

//               tr {
//                 page-break-inside: avoid;
//                 page-break-after: auto;
//               }

//               thead {
//                 display: table-header-group;
//               }

//               tfoot {
//                 display: table-footer-group;
//               }

//               .noPrint {
//                 display: none !important;
//               }
//             }

//             /* Screen view styles */
//             @media screen {
//               .styled-table tbody tr:hover {
//                 background-color: #e2e8f0;
//                 transition: background-color 0.2s ease;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-section">
//             ${printContent}
//           </div>
//           <script>
//             window.onload = function () {
//               setTimeout(() => {
//                 window.print();
//                 setTimeout(() => { window.close(); }, 500);
//               }, 200);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   } else {
//     console.error("Failed to open print window.");
//   }
// }




printPage4() {
  const printSection = document.getElementById('print-section');
  if (!printSection) {
    console.error("Print section not found!");
    return;
  }

  const printContent = printSection.innerHTML;

  const screenWidth = window.screen.availWidth;
  const windowWidth = 1400;
  const leftPosition = screenWidth - windowWidth - 50;

  const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              margin: 0;
              padding: 10px;
              background: white;
            }

            .report-container {
              border-radius: 0;
              box-shadow: none;
              overflow: visible;
              margin: 0 auto;
              background: white;
              max-width: 100%;
            }

            .report-header {
              background: #f8f9fa;
              color: #131212;
              padding: 0;
              display: table;
              width: 100%;
              table-layout: fixed;
              border-collapse: collapse;
              margin-bottom: 0;
              border: 1px solid #0d0d0e;
              border-bottom: none;
            }

            .header-row {
              display: table-row;
            }

            .company-name,
            .report-title,
            .report-meta {
              display: table-cell;
              vertical-align: middle;
              padding: 12px 10px;
              border-right: 1px solid #0d0d0e;
              border-left: 1px solid #0d0d0e;
            }

            .company-name {
              width: 25%;
              font-size: 16px;
              font-weight: bold;
              text-align: left;
              white-space: nowrap;
              border-left: none;
            }

            .report-title {
              width: 50%;
              font-size: 16px;
              font-weight: bold;
              text-align: center;
              white-space: nowrap;
            }

            .report-meta {
              width: 25%;
              font-size: 16px;
              text-align: right;
              line-height: 1.5;
              border-right: none;
            }

            .report-meta .report-type {
              display: block;
              font-weight: 600;
            }

            .report-meta .date-range {
              display: block;
              margin-top: 2px;
            }

            .table-responsive {
              overflow-x: auto;
              background: white;
              padding: 0;
            }

            .styled-table {
              width: auto !important;
              border-collapse: collapse;
              font-size: 16px;
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              table-layout: auto;
            }

            .styled-table th,
            .styled-table td {
              width: 1%;
              white-space: nowrap;
              padding: 8px 6px !important;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .styled-table thead {
              background: #e9ecef;
              color: #495057;
            }

            .styled-table thead th {
              padding: 12px 6px !important;
              text-align: center;
              font-weight: 600;
              border: 1px solid #111111;
              text-shadow: none;
              white-space: nowrap;
            }

            .styled-table tbody td {
              padding: 8px 10px;
              border: 1px solid #0d0d0e;
              vertical-align: middle;
              color: #000000;
            }

            .styled-table tbody tr:nth-child(even) {
              background-color: #f8fafc;
            }

            .office-header {
              background: #ffffff !important;
              color: #0c5460 !important;
              font-weight: bold !important;
              font-size: 16px !important;
            }

            .office-header td {
              padding: 10px !important;
            }

            .rep-header {
              background: #f9faf9 !important;
              color: #155724 !important;
              font-weight: bold !important;
              font-size: 16px !important;
            }

            .rep-header td {
              padding: 10px !important;
            }

            .rep-total {
              background: #fff3cd !important;
              color: #856404 !important;
              font-weight: bold !important;
              font-size: 14px !important;
            }

            .rep-total td {
              padding: 10px !important;
            }

            .office-total {
              background: #f8d7da !important;
              color: #721c24 !important;
              font-weight: bold !important;
              font-size: 16px !important;
            }

            .office-total td {
              padding: 10px !important;
            }

            .styled-table tfoot {
              background: #e9ecef;
              color: #495057;
            }

            .grand-total {
              background: #e9ecef !important;
              color: #495057 !important;
            }

            .grand-total td {
              padding: 15px 10px !important;
              font-weight: bold !important;
              font-size: 16px !important;
              border: 1px solid #0e0f0f !important;
            }

            .data-row td {
              font-size: 18px !important;
              font-weight: 500 !important;
              color: #000000 !important;
            }

            .nowrap {
              white-space: nowrap;
            }

            .text-left {
              text-align: left !important;
            }

            .text-right {
              text-align: right !important;
            }

            .amount-cell {
              font-family: 'Courier New', monospace !important;
              background: #f7fafc !important;
              color: #000000 !important;
              font-weight: bold;
              text-align: right !important;
            }

            /* Print-specific styles */
            @media print {
              @page {
                size: A3 landscape;
                margin: 10mm;
              }

              body {
                padding: 0;
              }

              .report-container {
                box-shadow: none;
                border-radius: 0;
                margin: 0;
              }

              .report-header {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }

              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }

              .office-header,
              .rep-header,
              .rep-total,
              .office-total,
              .grand-total,
              .styled-table thead,
              .styled-table tfoot {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }

              table {
                page-break-inside: auto;
              }

              tr {
                page-break-inside: avoid;
                page-break-after: auto;
              }

              thead {
                display: table-header-group;
              }

              tfoot {
                display: table-footer-group;
              }

              .noPrint {
                display: none !important;
              }
            }

            /* Screen view styles */
            @media screen {
              .styled-table tbody tr:hover {
                background-color: #e2e8f0;
                transition: background-color 0.2s ease;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function () {
              setTimeout(() => {
                window.print();
                setTimeout(() => { window.close(); }, 500);
              }, 200);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

    exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}


}
